import { reactive } from 'vue'
import actions from '@/store/table/actions'
import state from '@/store/table/state'
import getters from '@/store/table/getters'

export const tableModule = {
    state: reactive(state),
    actions,
    getters,
}
